import { IconProps } from "../types";

export const FileUploadIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M4.60676 1.5C3.24021 1.5 2.5 2.28364 2.5 3.74543V13.247C2.5 14.7088 3.24021 15.5 4.60676 15.5H12.3932C13.7598 15.5 14.5 14.7088 14.5 13.247V6.00592C14.5 5.60657 14.3505 5.22228 14.0872 4.94349L11.2758 1.94456C11.0053 1.65823 10.6423 1.5 10.2651 1.5L4.60676 1.5ZM13.0979 13.1868C13.0979 13.7293 12.8488 14.0156 12.3078 14.0156H4.68505C4.15125 14.0156 3.89502 13.7293 3.89502 13.1868V3.81324C3.89502 3.27826 4.14413 2.98439 4.68505 2.98439H9.79537V5.7648C9.79537 6.17922 10.1157 6.5183 10.5071 6.5183H13.0979V13.1868ZM8.9911 7.23412L10.5783 8.76372C10.7135 8.88428 10.7705 9.02745 10.7705 9.20075C10.7705 9.52476 10.5285 9.76588 10.2224 9.76588C10.073 9.76588 9.90925 9.68299 9.81673 9.56243L9.46085 9.17061L9.11922 8.78633V11.4612C9.11922 11.8229 8.83452 12.0791 8.5 12.0791C8.16548 12.0791 7.87367 11.8229 7.87367 11.4612V8.78633L7.53203 9.17061L7.17616 9.56243C7.07651 9.68299 6.91993 9.76588 6.77046 9.76588C6.4573 9.76588 6.22242 9.52476 6.22242 9.20075C6.22242 9.01991 6.27936 8.88428 6.41459 8.76372L8.00178 7.23412C8.16548 7.08342 8.30783 7.00054 8.5 7.00054C8.69217 7.00054 8.83452 7.08342 8.9911 7.23412Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
